import { NotificationData, notifications } from '@mantine/notifications';

import InfoCircle from '@assets/info-circle.svg';

import styles from './index.module.css';

const useNotifications = () => {
  const showErrorNotification = (notificationData: NotificationData) =>
    notifications.show({
      color: 'error',
      radius: 'md',
      withBorder: true,
      className: styles.error,
      icon: <InfoCircle />,
      ...notificationData
    });

  return { showErrorNotification };
};
export default useNotifications;
